// extracted by mini-css-extract-plugin
export default {"layout":"_5D1ak58_","mobile-button":"_5D3uqMv2","desktop-button":"_5DkkdiaN","error":"_5DCYzvxI"};